import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Game} from "../Game";
import {BgCarousel} from "../components/BgCarousel";
import {gsap} from "gsap";
import {GameFeatureMode} from "../enums/Enum";
import {Background} from "../components/Background";

export class BackgroundElements extends PIXI.Container implements StageLayer {
    private _backgroundContainer: PIXI.Container;
    private _bgCarousel: BgCarousel;
    private _gameType: string = "";

    constructor() {
        super();
        this.name = "Mental2BackgroundElements";
        this.init();
    }

    public onOrientationChanged() {

    }

    public onResize() {

    }

    public setMode(mode: string) {
        const toLevel: number = this._bgCarousel.getLevelByMode(mode as GameFeatureMode);
        this._bgCarousel.setTo(toLevel, (Game.model.isRestore || Game.apiPlugin.isReplay) ? 0 : 1.6);
        if (Game.model.isRestore && Game.model.data.nextMode === GameFeatureMode.RESPIN) {
            Game.backgroundElements.glitchMainToReSpin();
        }
    }

    public playLiftAnim(mode: GameFeatureMode): gsap.core.Timeline {
        const toLevel: number = this._bgCarousel.getLevelByMode(mode);
        const currentLevel: number = this._bgCarousel.currentLevel;
        mode === GameFeatureMode.NORMAL ? this.clockPlay() : this.clockStop();

        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add([
            () => {
                if (currentLevel !== 0) {
                    this._bgCarousel.bgList[currentLevel].playAnim("flicker_left", false);
                    if(currentLevel === 1){
                        this._bgCarousel.bgList[this._bgCarousel.currentLevel]?.wallClock?.playClockFlickerLeft();
                    }
                }
                Game.lift.updateDisplay(currentLevel, (toLevel - currentLevel));
            },
            Game.lift.show(),
            this._bgCarousel.onLiftCome(currentLevel, toLevel),
        ], 0.1);
        tl.add([
            Game.lift.move(currentLevel, toLevel),
            this._bgCarousel.moveTo(toLevel),
        ]);
        tl.add(() => {
            this._bgCarousel.bgList[toLevel].playAnim("flicker_left", false);
            if(toLevel === 1){
                this._bgCarousel.bgList[this._bgCarousel.currentLevel]?.wallClock?.playClockFlickerLeft();
            }
        });
        tl.add(Game.lift.stop());
        tl.add(this._bgCarousel.onLiftOut(toLevel), "<0.6");
        tl.add(() => {
            this._bgCarousel.bgList[toLevel].playAnim("animation", false);
        });
        return tl;
    }

    public onPostIntroDone(): void {
        this._bgCarousel.onIntroDone();
    }

    public onPostIntroStart(): void {
        this._bgCarousel.onIntroStart();
    }

    public playFlickerAnim(loop: boolean = false): void {
        switch (Game.model.data.mode) {
            case GameFeatureMode.RESPIN:
            case GameFeatureMode.FREESPIN:
            case GameFeatureMode.FREESPIN_SUPER:
            case GameFeatureMode.FREESPIN_COOL:
                this._gameType = Game.model.data.mode;
                break;
            default:
                this._gameType = "main";
                this._bgCarousel.bgList[this._bgCarousel.currentLevel]?.wallClock?.playClockFlicker();
                break;
        }
        const anim: string = Game.model.data.mode === GameFeatureMode.RESPIN ? "dental surgeon_flicker" : "flicker";
        this._bgCarousel.bgList[this._bgCarousel.currentLevel].playAnim(anim, loop);
    }

    public glitchMainToReSpin(): gsap.core.Timeline {
        const currentBg: Background = this._bgCarousel.bgList[this._bgCarousel.currentLevel];
        const clockHideTl: gsap.core.Timeline = currentBg.wallClock.hide();
        clockHideTl.add(() => {
            this._bgCarousel.bgList[this._bgCarousel.currentLevel].playAnim("main_to_dental surgeon", false)
        }, 0);
        return clockHideTl;
    }

    public glitchReSpinToMain(): gsap.core.Timeline {
        const currentBg: Background = this._bgCarousel.bgList[this._bgCarousel.currentLevel];
        const clockHideTl: gsap.core.Timeline = currentBg.wallClock.show();
        clockHideTl.add(() => {
            this._bgCarousel.bgList[this._bgCarousel.currentLevel].playAnim("dental surgeon_to_main", false);
        }, 0);
        return clockHideTl;
    }

    public scaleTo(scale: number, duration: number): gsap.core.Timeline {
        return this._bgCarousel.bgList[this._bgCarousel.currentLevel].scaleTo(scale, duration);
    }

    public stopFlickerAnim(): void {
        const currentBg: Background = this._bgCarousel.bgList[this._bgCarousel.currentLevel];
        const currentTrackAnim: string = currentBg.getCurrentAnimName();
        currentBg.stopAnim();
        if (currentBg.children[0].name !== "reception") {
            const anim: string = currentTrackAnim.includes("dental") ? "dental surgeon_normal" : "animation";
            currentBg.playAnim(anim, false);
        }
        if (this._gameType === "main") {
            this._bgCarousel.mainBg.wallClock.clockFlickerStop();
            this._gameType = "";
        }
    }

    public clockReverse() {
        this._bgCarousel.mainBg.wallClock.clockReverse();
    }

    public clockStop() {
        this._bgCarousel.mainBg.wallClock.clockStop();
    }

    public clockPlay() {
        this._bgCarousel.mainBg.wallClock.clockPlay();
    }

    public clockSetOnTime() {
        this._bgCarousel.mainBg.wallClock.clockSetOnTime();
    }

    private init() {
        this._bgCarousel = new BgCarousel();
        this.addChild(this._bgCarousel);
        this.onOrientationChanged();
        this.onResize();
    }

    private swapBackgroundTo(newBackground: PIXI.Sprite) {
        this._backgroundContainer.addChildAt(newBackground, 0);
        if (this._backgroundContainer.children.length > 1) {
            this._backgroundContainer.removeChildren(1);
        }
    }
}